// extracted by mini-css-extract-plugin
export var headerCell = "_3q-1";
export var loadingSpinnerContainer = "_3q-4";
export var rowWrapper = "_3q-3";
export var standaloneTable = "_3q-5";
export var table = "_3q-0";
export var white = "_3q-2";